import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Navbardesign from "../Navbar";
import Footer from "../FooterDomain/Footerdata";
import ContactBar from "../Fixedpossion/Fixedposion";
import Testimonials from "../Testimonalprocess/Testimonalsprocess";
import Separtedcarddesigntestionals from "./Testmonialprocess";

const Idmatchprocessinperpage = () => {
  const { id } = useParams();
  const [testimonial, setTestimonial] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const imageurl = "https://dev.mithahomes.com/backend";
  useEffect(() => {
    const fetchTestimonial = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://dev.mithahomes.com/backend/api/testimonials/get/${id}`,
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        if (result.success && result.data) {
          setTestimonial(result.data);
        } else {
          throw new Error("No data found");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonial();
  }, [id]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontFamily: "Arial, sans-serif",
        }}
      >
        Loading testimonial...
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontFamily: "Arial, sans-serif",
          color: "red",
        }}
      >
        Error: {error}
      </div>
    );
  }

  if (!testimonial) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontFamily: "Arial, sans-serif",
        }}
      >
        No testimonial found
      </div>
    );
  }

  // Determine if content is video or image
  const isVideo = testimonial.ttype === "video";
  const mediaUrl = testimonial.timg || "";
  const mediaExtension = mediaUrl.split(".").pop().toLowerCase();
  const isVideoFile = ["mp4", "webm", "ogg"].includes(mediaExtension);

  return (
    <div
      style={{
        margin: 0,
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f0f0f0",
        minHeight: "100vh",
      }}
    >
      <Navbardesign />
      <br />
      <br />
      <br />
      <br />
      <div
        style={{
          maxWidth: "1000px",
          margin: "20px auto",
          padding: 0,
          backgroundColor: "white",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        }}
      >
        {/* Header Section */}
        <div
          style={{
            backgroundColor: "#f7f7f7",
            padding: "30px 20px",
            textAlign: "center",
          }}
        >
          <p
            style={{
              margin: "0 0 5px 0",
              fontSize: "16px",
              color: "#333",
            }}
          >
            {testimonial.tsub || "Consultant Surgeon, GVN Hospitals, Trichy"}
          </p>

          <h1
            style={{
              margin: "5px 0 20px 0",
              fontSize: "26px",
              fontWeight: "bold",
              color: "#222",
            }}
          >
            {testimonial.ttitle ||
              "Dr. S. Rakesh Natesan M.S., FIAGES., FMAS.,"}
          </h1>

          <div
            style={{
              display: "inline-block",
              borderRadius: "50%",
              width: "150px",
              height: "150px",
              overflow: "hidden",
              border: "4px solid #fff",
              boxShadow: "0 0 10px rgba(0,0,0,0.2)",
              backgroundColor: "#e0e0e0",
            }}
          >
            {isVideo || isVideoFile ? (
              <video
                controls
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              >
                <source src={mediaUrl} type={`video/${mediaExtension}`} />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={imageurl + mediaUrl || "placeholder_image.jpg"}
                alt={testimonial.ttitle || "Testimonial"}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
                onError={(e) => {
                  e.target.src = "placeholder_image.jpg";
                }}
              />
            )}
          </div>
        </div>

        {/* Content Section */}
        <div
          style={{
            padding: "40px 80px",
            textAlign: "center",
            backgroundColor: "#fff",
          }}
        >
          <p
            style={{
              margin: 0,
              fontSize: "16px",
              lineHeight: "1.6",
              color: "#444",
              whiteSpace: "pre-line",
            }}
          >
            {testimonial.tdet ||
              "Just wanted to say a sincere thank you to **Mr. Mohan and his team** for all the work they have done for us in creating our amazing new space - **Mitha Vriksham Apartment**. We love it and were continually impressed by their **professionalism, attention to detail, care and the support** they provided us during this project. They made the process so easy for us and we are very grateful for joining hands with the best and trustable construction company in town. Once again my heartfelt thanks to **Mitha Construction and Development**."}
          </p>

          {/* Video Link if exists */}
          {testimonial.tvlink && (
            <div style={{ marginTop: "20px" }}>
              <a
                href={testimonial.tvlink}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#0066cc",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                Watch Video Testimonial
              </a>
            </div>
          )}
        </div>

        <div style={{ height: "20px", backgroundColor: "white" }}></div>
      </div>
      {/* <p>Dineshkumar</p> */}
      <Separtedcarddesigntestionals />

      <Footer />
      <br />
      <br />
      <br />

      <ContactBar />
    </div>
  );
};

export default Idmatchprocessinperpage;
